module.exports = __webpack_public_path__ + "img/20251212.928efde7.png";